import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets, whenRtl } from '@indriver/vandermeer';
import '@indriver/yrel';
import preset, { floatingContainerPreset } from './preset.js';

var style = getPresets(preset, {});

var getBoxBackground = function getBoxBackground(_ref) {
  var invalid = _ref.invalid,
      disabled = _ref.disabled,
      focused = _ref.focused;

  if (disabled) {
    return "" + style.backgroundDisabled();
  }

  if (focused) {
    return "" + style.backgroundFocused();
  }

  if (invalid) {
    return "" + style.backgroundInvalid();
  }

  return "" + style.backgroundDefault();
};

var getBoxBorderColor = function getBoxBorderColor(_ref2) {
  var invalid = _ref2.invalid,
      disabled = _ref2.disabled,
      focused = _ref2.focused;

  if (disabled) {
    return "" + style.borderDisabled();
  }

  if (focused) {
    return "" + style.borderFocused();
  }

  if (invalid) {
    return "" + style.borderInvalid();
  }

  return "" + style.borderDefault();
};

var getBoxHoverBorder = function getBoxHoverBorder(_ref3) {
  var invalid = _ref3.invalid,
      disabled = _ref3.disabled,
      focused = _ref3.focused;

  if (disabled) {
    return "" + style.borderDisabled();
  }

  if (focused) {
    return "" + style.borderFocused();
  }

  if (invalid) {
    return "" + style.borderInvalid();
  }

  return "" + style.borderHover();
};

var getHoveredBackground = function getHoveredBackground(_ref4) {
  var disabled = _ref4.disabled,
      focused = _ref4.focused;

  if (disabled) {
    return "" + style.backgroundDisabled();
  }

  if (focused) {
    return "" + style.backgroundDefault();
  }

  return "" + style.backgroundHover();
};

var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bn7cu42",
  vars: {
    "bn7cu42-0": [function (_ref5) {
      var design = _ref5.design;
      return design === 'floating' ? '56px' : '48px';
    }],
    "bn7cu42-1": [function (_ref6) {
      var disabled = _ref6.disabled;

      if (disabled) {
        return 'default';
      }

      return 'text';
    }],
    "bn7cu42-2": [getBoxBackground],
    "bn7cu42-3": [getBoxBorderColor],
    "bn7cu42-5": [getHoveredBackground],
    "bn7cu42-6": [getBoxHoverBorder]
  }
});
var Prefix = /*#__PURE__*/styled("div")({
  name: "Prefix",
  class: "pgi2hjf",
  vars: {
    "pgi2hjf-0": [function (_ref7) {
      var focused = _ref7.focused;
      return focused ? style.iconFocusedColor() : style.iconColor();
    }]
  }
});
var Postfix = /*#__PURE__*/styled("div")({
  name: "Postfix",
  class: "p13ih4tu",
  vars: {
    "p13ih4tu-0": [function (_ref8) {
      var focused = _ref8.focused;
      return focused ? style.iconFocusedColor() : style.iconColor();
    }]
  }
});
var InputElement = /*#__PURE__*/styled("input")({
  name: "InputElement",
  class: "itgr0ej",
  vars: {
    "itgr0ej-0": [function (_ref9) {
      var design = _ref9.design;
      return design === 'floating' ? '18px' : '0';
    }],
    "itgr0ej-1": [function (_ref10) {
      var disabled = _ref10.disabled;

      if (disabled) {
        return "" + style.textColorDisabled();
      }

      return "" + style.textColor();
    }],
    "itgr0ej-2": [function (_ref11) {
      var disabled = _ref11.disabled;

      if (disabled) {
        return "" + style.textColorDisabled();
      }

      return "" + style.placeholderColor();
    }]
  }
});
var floatingContainerStyle = getPresets(floatingContainerPreset, {
  padding: 'state'
});
var leftRtl = whenRtl('unset', '0');
var rightRtl = whenRtl('0', 'unset');

var paddingRtl = function paddingRtl(props) {
  if (props.withOffset === false) {
    return 0;
  }

  var state = props.state;

  if (props.state === 'prefixed') {
    state = whenRtl('postfixed', 'prefixed')(props);
  }

  if (props.state === 'postfixed') {
    state = whenRtl('prefixed', 'postfixed')(props);
  }

  return floatingContainerStyle.padding(_extends({}, props, {
    state: state
  }));
}; // TODO: FloatingContainer вынести в internal/floating-contaier и переиспользовать в компонентах


var FloatingContainer = /*#__PURE__*/styled("div")({
  name: "FloatingContainer",
  class: "fw4xcs5",
  vars: {
    "fw4xcs5-0": [leftRtl],
    "fw4xcs5-1": [rightRtl],
    "fw4xcs5-3": [paddingRtl]
  }
});
var transformOriginRtl = whenRtl('right', '0');
var FloatingLabel = /*#__PURE__*/styled("label")({
  name: "FloatingLabel",
  class: "f12bgeeg",
  vars: {
    "f12bgeeg-0": [function (_ref12) {
      var floating = _ref12.floating;
      return floating ? '14px' : 'inherit';
    }],
    "f12bgeeg-1": [function (_ref13) {
      var floating = _ref13.floating;
      return floating ? 'translateY(-11px)' : 'translateY(0)';
    }],
    "f12bgeeg-2": [transformOriginRtl]
  }
});

export { Box, FloatingContainer, FloatingLabel, InputElement, Postfix, Prefix };


require('../../styles-linaria/input/input.styles.css');
